import App from './App.vue';
import { createApp } from 'vue';

import { createRouter, createWebHistory } from 'vue-router';
import store from './store';
import routes from './router';
import './services/http';
import '@dragdroptouch/drag-drop-touch'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faPhone,
    faHome,
    faUser,
    faUserPlus,
    faSignInAlt,
    faSignOutAlt,
    faArrowRightFromBracket,
    faCamera,
    faFilePdf,
    faArrowsAltV,
    faSortDown,
    faSortUp,
    faTrashCan,
    faPencil,
    faClose,
    faFileText,
    faExchange,
    faCircleInfo,
    faRotateRight,
} from '@fortawesome/free-solid-svg-icons';
import { reportVueAppOpened } from './services/boot.service';
import { getUser, hasUserSession } from './services/tokenStore';
import { App as CapacitorApp } from '@capacitor/app';
import { isNativeApp } from './utils/platform';
import { initClientIdentity } from './utils/clientIdentity';
import { initNativeShell } from './utils/nativeShell';

library.add(
    faPhone,
    faExchange,
    faFileText,
    faClose,
    faPencil,
    faCamera,
    faTrashCan,
    faSortUp,
    faSortDown,
    faArrowsAltV,
    faFilePdf,
    faHome,
    faUser,
    faUserPlus,
    faSignInAlt,
    faSignOutAlt,
    faArrowRightFromBracket,
    faCircleInfo,
    faRotateRight,
);

const router = createRouter({
    history: createWebHistory(),
    base: __dirname,
    routes
})

router.beforeEach((to, from, next) => {
    const publicPages = ['/portal/login', '/portal/home'];
    const adminPages = ['/portal/create_user', '/portal/admin_system', '/portal/admin_stats'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = hasUserSession();

    if (authRequired && !loggedIn) {
        next('/portal/login');
        return;
    }

    if (adminPages.includes(to.path)) {
        const user = getUser();
        if (!user || user.role !== 'administrator') {
            next('/portal/home');
            return;
        }
    }

    next();
});

if (isNativeApp()) {
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
            router.back();
        } else {
            CapacitorApp.exitApp();
        }
    });
}

const app = createApp(App);

app.use(router);
app.use(store);
app.use(Toast);

app.component("font-awesome-icon", FontAwesomeIcon);

initClientIdentity().finally(() => {
    app.mount('#app');
    reportVueAppOpened();
    initNativeShell();
});
